import React, { useEffect, useState, useRef } from "react";
import { Table, Modal, Button, Carousel } from "react-bootstrap";
import { convertCurrency, numberFormat } from "../../helper";
import _ from "lodash";
import { QRCode } from "react-qrcode-logo";

import CarouselScreen from "./CarouselScreen";
import { GET_BANKS } from "../../apollo/bank/query";
import { useLazyQuery } from "@apollo/client";
import { S3_URL, USER_KEY } from "../../const";


const bankLogos = [
  {
    id: 1,
    logo: "https://www.jdbbank.com.la/wp-content/uploads/2019/05/jdb-ico.png"
  },
  {
    id: 2,
    logo: "/assets/image/bcel-logo.png"
  },
  {
    id: 3,
    logo: "/assets/image/ib-logo.png"
  },
  {
    id: 4,
    logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSAaA92cPEkNBK2m4dBAwv-bCUVifRYzkRSzw&s"
  },
  {
    id: 5,
    logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTtWVw0jkJNbp-I6SlDFVkROXzxZPfDJU35FVLvMi8bObZuOZQ-3oHUcs7LsRfCxmyG59o&usqp=CAU"
  },
  {
    id: 5,
    logo: "/assets/image/Thai-qr.webp"
  },
  {
    id: 5,
    logo: "/assets/image/union-pay.png"
  },
]


export default function CustomerDesktop() {
  const shopId = JSON.parse(localStorage.getItem(USER_KEY))?.data?.shop?.id;
  const [cartDatas, setCartDatas] = useState([]);
  const tableContainerRef = useRef(null);
  const [exchangeRate, setExchangeRate] = useState(null);
  const [show, setShow] = useState(false);
  const [bank, setBank] = useState({});
  const [dataCustom, setDataCustom] = useState();
  const [screenStatus, setScreenStatus] = useState({
    isTitleCms: true,
    isBannerCms: true,
    isTitleBannerCms: true,
    isRateCms: true,
    isTextMarqueeCms: true,
  });

  const [getBanks, { loading: banksLoading }] = useLazyQuery(GET_BANKS, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      console.log("data: ", data);
      if(data?.banks?.data.length > 0 && data?.banks?.data[0]?.image){
        setBank(data?.banks?.data[0]);
      }
    },
  });

  const paymentQR = JSON.parse(localStorage.getItem("PAYMENT_QR_DATA"));
  // console.log("paymentQR: ", paymentQR);

  const handleClose = () => setShow(false);

  // Load initial data from localStorage
  useEffect(() => {
    const storedCartDatas = localStorage.getItem("CART_DATAS");

    if (storedCartDatas) {
      setCartDatas(JSON.parse(storedCartDatas));
    }
    handleBanks();
  }, []);

  // Listen for changes in localStorage
  useEffect(() => {
    const handleStorageChange = (event) => {
      let _rates = event?.storageArea
        ? JSON.parse(event?.storageArea?.getItem("RATE_BY_SHOP"))
        : null;
      // let _isQrcode = event?.storageArea ? JSON.parse(event?.storageArea?.getItem('QR_CODE_STATUS')) : null;
      let _customThemeShop = event?.storageArea
        ? JSON.parse(event?.storageArea?.getItem("CUSTOM_THEME_BY_SHOP"))
        : null;

      setDataCustom(_customThemeShop?.datas);
      setScreenStatus({
        isTitleCms: _customThemeShop?.datas?.isTitleCms,
        isBannerCms: _customThemeShop?.datas?.isBannerCms,
        isTitleBannerCms: _customThemeShop?.datas?.isTitleBannerCms,
        isRateCms: _customThemeShop?.datas?.isRateCms,
        isTextMarqueeCms: _customThemeShop?.datas?.isTextMarqueeCms,
      });
      setExchangeRate(_rates?.datas);
      if (event?.key === "CART_DATAS") {
        const newCartDatas = JSON.parse(event.newValue);

        setCartDatas(newCartDatas?.datas);
      }
    };

    window.addEventListener("storage", handleStorageChange);

    // Clean up the event listener
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  // Scroll to the bottom of the table whenever cartDatas changes
  useEffect(() => {
    if (tableContainerRef.current) {
      tableContainerRef.current.scrollTop =
        tableContainerRef.current.scrollHeight;
    }
  }, [cartDatas]);

  const imageEmpty =
    "https://cdn-icons-png.flaticon.com/512/11329/11329060.png";

  const handleBanks = async () => {
    try {
      if (banksLoading || bank.image || !shopId) return;
      await getBanks({
        variables: {
          limit: 100,
          orderBy: "createdAt_DESC",
          where: {
            shop: shopId,
            isDeleted: false,
            isActiveDefault: true,
          },
        },
      });
    } catch (error) {
      console.log("Error in handleBanks: ", error);
    }
  }

  return (
    <React.Fragment>
      <div className="card-cm-container">
        {paymentQR ? (
          <div className="child-cm">
            <br />
            <div className="w-100 d-flex align-items-center gap-3">
              <img
                src="/assets/image/policy-logo.png"
                alt="Policy Logo"
                className="img-fluid"
                style={{ width: "40px", height: "40px" }}
              />
              <div style={{ marginTop: "1rem" }}>
                <p className="fw-medium" style={{ fontSize: "1.2rem" }}>
                  ທຸລະກຳໄດ້ຮັບການກວດສອບຄວາມຖືກຕ້ອງ ແລະ ຄວາມປອດໄພສຳເລັດ
                </p>
              </div>
            </div>
            <div className="w-70  d-flex flex-column align-items-center justify-content-center" style={{ marginTop: "2rem" }}>
              <h5>ຄວາມປອດໄພຂອງທ່ານຄືສິ່ງທີ່ເຮົາຄໍານຶງເຖິງອັນດັບທໍາອິດ.
              </h5>
              <h5>
                ຊໍາລະເງິນຢ່າງໝັ້ນໃຈ ແລະ ຂໍ້ມູນຂອງທ່ານຈະຖືກປົກປ້ອງສະເໝີດ້ວຍເທັກໂນໂລຊີຂັ້ນສູງ.
              </h5>
            </div>
            <h5 className="m-4">
              <b>ສະເເກນ QR ເພື່ອຈ່າຍ</b>
            </h5>

            <div
              style={{
                position: "relative",
                marginTop: 5,
                padding: "2em",
                border: "1px solid #f2f2f2",
                borderRadius: "10px",
                boxShadow: "rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px",
              }}
            >
              <QRCode
                size={310}
                value={
                  paymentQR?.qrCode ?? "345345534534534554656756734535435345"
                }
              />
              <div
                className="icon-overlay"
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  zIndex: 10,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                  height: "100%",
                }}
              >
                <img
                  src="https://lapnet.com.la/storage/products/January2023/RJIZBNdN4639D6wjTZBb.png" // Replace with the path to your image
                  alt="Center Images" // Add appropriate alt text for accessibility
                  style={{
                    maxWidth: "12%",
                    maxHeight: "12%",
                    background: "#fff",
                    padding: "5px",
                  }}
                />
              </div>
            </div>
            <br />
            <div>
              {/* <h5 className="">
              <b>ທະນະຄານທີ່ຮອງຮັບການຊໍາລະ</b>
            </h5> */}
            </div>
            <div className="d-flex gap-4 mb-4 mt-4">
              {bankLogos?.map((bankLogo) => (
                <img
                  key={bankLogo.id}
                  src={bankLogo.logo}
                  alt={bankLogo.id}
                  className="img-fluid"
                  style={{ width: "45px", height: "45px", objectFit: "cover", }}
                />
              ))}
            </div>

          </div>
        ) : (
          <div className="child-cm">
            {bank?.image ? (
              <>
                <h3>🙏ສະບາຍດີລູກຄ້າ🙏</h3>
                <h4>👇ສາມາດລະເງີນຜ່ານ QR Code👇</h4>
                <div className="w-100 h-100">
                  <Carousel 
                    controls={false} 
                    indicators={false} 
                    interval={null} 
                    className="h-100"
                  >
                      <Carousel.Item key={bank?.id} className="h-100">
                        <img
                          src={`${S3_URL}${bank?.image}`}
                          alt={bank?.bankName}
                          className="w-100 h-100"
                          style={{ 
                            objectFit: 'contain',
                            maxHeight: '60vh'
                          }}
                        />
                      </Carousel.Item>
                  </Carousel>
                </div>

                <h4>ໂອກາດນ່າເຊີນໃຫມ່ ຂໍຂອບໃຈສຳລັບການອຸດຫນຸນ🙏</h4>
              </>
            ) : (
            <>
              {screenStatus?.isTitleCms && <h3>ຍິນດີຕ້ອນຮັບ</h3>}
              <div className="child-swiper">
                {screenStatus?.isBannerCms && (
                  <CarouselScreen
                    isTitleBannerCms={screenStatus?.isTitleBannerCms}
                  />
                )}
              </div>
              <br />
              <br />
              {screenStatus?.isRateCms && (
                <h4>
                  ເລດເງິນບາດ: {numberFormat(exchangeRate?.baht ?? 0)}, ເລກເງິນໂດລາ:{" "}
                  {numberFormat(exchangeRate?.usd ?? 0)}
                </h4>
              )}
              {screenStatus?.isTitleCms &&
                screenStatus?.isBannerCms &&
                screenStatus?.isRateCms &&
                paymentQR?.qrCode && <div>Show QR here</div>}
            </>
            )}
          </div>
        )}

        <div className="child-cm">
          <div className="d-flex w-100 justify-content-between align-items-center pb-1 border-bottom">
            <h5>ລາຍການອໍເດີ້ </h5>
            {cartDatas?.label && <h5>{cartDatas?.label}</h5>}
          </div>
          <div
            style={{ overflowX: "auto", height: "50vh", textAlign: "center" }}
            ref={tableContainerRef}
          >
            {_.isEmpty(cartDatas?.data?.orders) ? (
              <img
                style={{ width: "40%", height: "60%" }}
                src={imageEmpty}
                alt="empty order"
              />
            ) : (
              <Table>
                <tbody>
                  {cartDatas?.data?.orders?.map((item, index) => (
                    <tr key={index}>
                      <td style={{ textAlign: "left", padding: 15, width: 20 }}>
                        {index + 1}
                      </td>
                      <td style={{ textAlign: "left", padding: 15 }}>
                        {item?.productName ?? "-"}
                      </td>
                      <td style={{ padding: 15 }}> {item?.amount ?? 0}</td>
                      <td style={{ textAlign: "right", padding: 15 }}>
                        {numberFormat(item?.totalPrice)}{" "}
                        {convertCurrency(item?.currency ?? "ກີບ")}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </div>
          <div className="d-flex w-100 justify-content-between align-items-center pt-2">
            <h5>ລວມເງິນ</h5>
            <h5>
              {numberFormat(cartDatas?.data?.orderGroup?.totalPrice ?? 0)} ₭
            </h5>
          </div>
          <div className="d-flex w-100 justify-content-between align-items-center">
            <h5></h5>
            <h5>
              {numberFormat(cartDatas?.data?.orderGroup?.sumPriceBaht ?? 0)} ฿
            </h5>
          </div>
          <div className="d-flex w-100 justify-content-between align-items-center">
            <h5></h5>
            <h5>
              {numberFormat(cartDatas?.data?.orderGroup?.sumPriceUsd ?? 0)} $
            </h5>
          </div>
          <div className="d-flex w-100 justify-content-between align-items-center">
            <h5>ສ່ວນຫຼຸດ</h5>
            <h5>
              {isNaN(cartDatas?.data?.orderGroup?.discount)
                ? "0"
                : numberFormat(cartDatas?.data.orderGroup?.discount ?? 0)}{" "}
              {!cartDatas?.data?.orderGroup?.discountType ? "%" : "₭"}{" "}
            </h5>
          </div>
          <div className="d-flex w-100 justify-content-between align-items-center">
            <h5>ຄ່າຂົນສົ່ງ</h5>
            <h5>
              {numberFormat(cartDatas?.data?.orderGroup?.shippingCost ?? 0)} ₭
            </h5>
          </div>

          {/* Total price */}
         {screenStatus?.isTextMarqueeCms && <div className="child-total-cm">
            {cartDatas?.data?.orderGroup?.sumPrice > 0 && (
              <h3>
                {numberFormat(cartDatas?.data?.orderGroup?.sumPrice ?? 0)} ກີບ
              </h3>
            )}
          </div>}
        </div>
      </div>

      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Modal heading</Modal.Title>
        </Modal.Header>
        <Modal.Body>Woohoo, you are reading this text in a modal!</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleClose}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>

      {/* show Qr */}
      {/* <WaitingPaymentModal 
    show={paymentQR ? true : false}
    title={"ສະເເກນເພື່ອຈ່າຍ"}
    paymentData={paymentQR}
    showClose={false}
     /> */}
    </React.Fragment>
  );
}
